<!--
  AddressCheckNotice -- the result of the back office's address check, shown
  under an address block (card #627). Presentational: it renders `result`
  (utils/addressCheck.js) and emits `accept` when the person takes the
  did-you-mean. It never saves or changes anything by itself.

  The root always renders (so the host can attach a data-testid) and is empty
  when there is nothing to say: verified, unavailable, or no check yet.
-->
<template>
  <div class="address-check-notice" aria-live="polite">
    <v-alert
      v-if="result && result.status === 'unverified'"
      type="warning"
      variant="tonal"
      density="comfortable"
      class="mb-2"
      data-testid="address-check-unverified"
    >
      We couldn't verify this address. Please check it. You can still save it
      as entered.
    </v-alert>
    <v-alert
      v-else-if="result && result.status === 'suggest'"
      type="warning"
      variant="tonal"
      density="comfortable"
      class="mb-2"
      data-testid="address-check-suggestion"
    >
      <p class="mb-1">
        We couldn't verify this address as entered. Did you mean:
      </p>
      <p class="font-weight-medium mb-1" data-testid="address-check-suggested-address">
        {{ suggestedText }}
      </p>
      <p v-if="result.zipOrStateChanged" class="mb-1" data-testid="address-check-zip-changed">
        The ZIP code or state changed. Check it before using it.
      </p>
      <p class="mb-2">Your entry stays as typed unless you use the suggestion.</p>
      <v-btn
        size="small"
        variant="outlined"
        data-testid="address-check-accept"
        @click="$emit('accept')"
      >
        Use suggested address
      </v-btn>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "AddressCheckNotice",
  props: {
    result: { type: Object, default: null },
  },
  emits: ["accept"],
  computed: {
    suggestedText() {
      const s = this.result && this.result.suggestion;
      if (!s) return "";
      const street = [s.line1, s.line2].filter(Boolean).join(", ");
      return `${street}, ${s.city}, ${s.state} ${s.postal_code}`;
    },
  },
};
</script>
